import template from './views/component.tpl.html';
import AlLandingpageGeneralComponentController from './controllers/component';

/**
 * @ngdoc component
 * @name festzelt-os.modules.guestlists.component:al-guestlist-general
 * @restrict EA
 * @element
 *
 * @description
 *
 * @example
 <example module="festzelt-os.modules.guestlists">
 <file name="index.html">
 <al-landingpage-general guestlist="{}"></al-landingpage-general>
 </file>
 </example>
 *
 */
angular
    .module('festzelt-os.modules.media')
    .component('alLandingpageGeneral', {
        bindings: {
            guestlist: '<',
            showContent: '<'
        },
        controller: AlLandingpageGeneralComponentController,
        controllerAs: 'vm',
        templateUrl: template
    });



// WEBPACK FOOTER //
// ./src/app/modules/guestlists/components/al-landingpage-editor/general/component.js